import { PencilIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs";
import Header from "../../components/Header";
import PageContainer from "../../components/PageContainer";
import Sidebar from "../../components/Sidebar";
import { usePermissions } from "../../context/PermissionsContext";
import { getJob } from "../../services/jobs/getJob";
import { updateJob } from "../../services/jobs/updateJob";
import EditTasksFromJob from "./EditTasksFromJob";
import { term } from "../../terms";

function EditJob() {
    const { can, permissionsLoading } = usePermissions();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const jobId = useParams().jobId;
    const navigate = useNavigate();
    /* const [job, setJob] = useState({
        name: "",
    }); */
    const [form, setForm] = useState({
        name: "",
    });
    const [isEditing, setIsEditing] = useState(false);
    const noPermissionMessage = "You don't have permission to do this.";
    const canReadPipelines =
        can("pipelines.read") || can("pipelines.write") || can("pipelines.delete");
    const canWritePipelines = can("pipelines.write");

    useEffect(() => {
        async function runOnLoad() {
            if (permissionsLoading) return;
            if (!canReadPipelines) {
                setLoading(false);
                return;
            }
            if (typeof jobId === "undefined") return;

            const job = await getJob(jobId);
            if (job.success === false) return navigate("/templates/jobs");
            setForm({
                name: job.data.job.name,
            });

            /* setJob({
                name: job.data.job.name,
            }); */

            setLoading(false);
        }
        runOnLoad();

        // eslint-disable-next-line
    }, [canReadPipelines, permissionsLoading]);

    const saveDetails = async () => {
        if (!canWritePipelines) {
            toast.error("You don't have permission to do this");
            return;
        }

        if (form.name == "") {
            toast.error("Name can't be empty");
            return;
        }
        const response = await updateJob(jobId, form.name);
        console.log(response);
        if (response.success) {
            /* setJob({ name: form.name }); */
            toast.success(response.data.message);
        } else {
            toast.error(response.data.message);
        }
        setIsEditing(false);
        /*  const res = await updateService({
      id: serviceId,
      name: form.name,
      isEfileStatusActive: form.isEfileStatusActive,
      isEveryItemRenewable: form.isEveryItemRenewable,
      departmentId: selectedDepartment.id,
    });

    if (res.data.success) {
      setService({ name: form.name });
      toast.success(res.data.message);
    } else { c z jnj hhhhhhhhhhhhhhhhhbgvgbggggggggggg     /
      toast.error(res.data.message);
    } */
    };

    const onHandleChangeInput = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const toggleEdit = () => {
        if (!canWritePipelines) return;
        setIsEditing(!isEditing);
    };

    return (
        <section>
            <Toaster />
            <ReactTooltip
                type="light"
                effect="solid"
                place="top"
                border={true}
                borderColor={"rgb(220,220,220)"}
                className="rounded-md bg-gray-50"
                multiline={false}
            />
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* Content area */}
                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    {/*  Site header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <PageContainer
                        isLoading={loading}
                        loadingText={`Loading ${term("pipeline_singular").toLowerCase()}...`}
                    >
                        <main>
                            <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                                <div className="flex flex-col items-start max-w-2xl">
                                    <Breadcrumbs
                                        home="/templates/jobs"
                                        pages={[
                                            {
                                                name: `${term("pipeline_singular")}`,
                                                href: `/templates/jobs`,
                                                current: true,
                                            },
                                        ]}
                                    />

                                    {/* Page header */}
                                    {/* <div className="w-full mt-12 mb-8 sm:flex sm:justify-between sm:items-center">

                                        <div className="mb-4 sm:mb-0">
                                            <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                                Edit Job
                                                <span className="font-normal text-slate-400">
                                                    {" "}
                                                    {job.name}{" "}
                                                </span>
                                            </h1>
                                        </div>
                                    </div> */}
                                    <h1 className="p-4 text-2xl font-bold md:text-3xl text-slate-800">
                                        {term("pipeline_singular")}
                                    </h1>
                                    {canReadPipelines ? (
                                        <>
                                        <div className="relative w-full pb-4 mt-4 bg-white border rounded-sm shadow-lg border-slate-200">
                                        {/* <header className="px-5 py-4 border-slate-200">
                                             <h2 className="font-semibold text-slate-800">
                                                Details
                                            </h2>
                                        </header> */}

                                        <div className="w-full px-5 py-4 space-y-5">
                                            <div className="flex justify-end font-medium">
                                                <span
                                                    data-tip={
                                                        canWritePipelines
                                                            ? "Edit"
                                                            : noPermissionMessage
                                                    }
                                                    className="inline-flex"
                                                >
                                                    <button
                                                        onClick={() => toggleEdit()}
                                                        type="submit"
                                                        disabled={!canWritePipelines}
                                                        className={`z-20 inline-flex text-sm font-medium border border-transparent rounded-sm shadow-sm outline-none w-fit ${
                                                            canWritePipelines
                                                                ? ""
                                                                : "opacity-50 cursor-not-allowed"
                                                        }`}
                                                    >
                                                        {isEditing ? (
                                                            <>Cancel</>
                                                        ) : (
                                                            <>
                                                                <PencilIcon className="w-4 h-4 mr-2" />
                                                                Edit Name
                                                            </>
                                                        )}
                                                    </button>
                                                </span>
                                            </div>

                                            <div>
                                                <label
                                                    htmlFor="name"
                                                    className="block text-sm font-medium text-gray-700"
                                                >
                                                    Name
                                                </label>
                                                <div className="mt-1">
                                                    <input
                                                        name="name"
                                                        disabled={
                                                            !isEditing ||
                                                            !canWritePipelines
                                                        }
                                                        type="text"
                                                        value={form.name}
                                                        onChange={(e) =>
                                                            onHandleChangeInput(e)
                                                        }
                                                        className={`w-full shadow-sm border border-slate-300 rounded-sm p-2 ${
                                                            !isEditing &&
                                                            "focus:outline-none focus:ring-0 bg-gray-200"
                                                        }`}
                                                    />
                                                </div>
                                            </div>
                                            {isEditing && (
                                                <div className="flex justify-start w-full">
                                                    <span
                                                        data-tip={
                                                            canWritePipelines
                                                                ? "Save"
                                                                : noPermissionMessage
                                                        }
                                                        className="inline-flex"
                                                    >
                                                        <button
                                                            onClick={() =>
                                                                saveDetails()
                                                            }
                                                            type="submit"
                                                            disabled={
                                                                !canWritePipelines
                                                            }
                                                            className={`z-20 inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-teal-500 border border-transparent rounded-sm shadow-sm ${
                                                                canWritePipelines
                                                                    ? "hover:bg-teal-600"
                                                                    : "opacity-50 cursor-not-allowed"
                                                            } focus:outline-none focus:ring-0`}
                                                        >
                                                            Save
                                                        </button>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <EditTasksFromJob
                                        title={term("step_plural")}
                                        jobId={jobId}
                                    />
                                        </>
                                    ) : (
                                        <div className="w-full p-4 text-sm border rounded-sm border-slate-200 text-slate-600">
                                            You don't have permission to view pipelines.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </main>
                    </PageContainer>
                </div>
            </div>
        </section>
    );
}
export default EditJob;
